import { useLayoutEffect, useRef } from 'react';
import { useLocation, useNavigate, useNavigationType } from 'react-router-dom';
import { adresVozvrata, etoKartochkaZapisi } from './adresVozvrata';

/** All booking links and programmatic transitions retain their source, including query and hash.
 * History state survives reload; receipt steps and another booking keep the original source.
 * Embedded client/messenger cards keep their existing owner-controlled close callback.
 */
export function VozvratIzZapisi() {
  const location = useLocation();
  const navigate = useNavigate();
  const action = useNavigationType();
  const previous = useRef(location);
  useLayoutEffect(() => {
    const prev = previous.current;
    previous.current = location;
    if (!etoKartochkaZapisi(location.pathname) || action === 'POP' || prev.key === location.key
      || adresVozvrata(location.state?.otkuda)) return;
    const source = etoKartochkaZapisi(prev.pathname)
      ? adresVozvrata(prev.state?.otkuda)
      : adresVozvrata(prev.pathname + prev.search + prev.hash);
    if (source) navigate(location.pathname + location.search + location.hash, {
      replace: true, state: { ...location.state, otkuda: source },
    });
  }, [location, action, navigate]);
  return null;
}
